module.exports = __webpack_public_path__ + "img/sonic-boom-animation.424224aa.png";